import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { getLang } from "@/util/config";

const cdnUrl = process.env.NODE_ENV === 'development'?'/static-statistics/': 'https://hbg-fed-static-prd.hbfile.net/v4/fed-hbg-u-board/'

i18n.use(Backend).use(LanguageDetector).use(initReactI18next).init({
        load: 'currentOnly',
        lng: getLang(),
        backend: {
            loadPath: function (lngs: Array<string>, namespaces: Array<string>) {
                if (lngs.includes('dev')) {
                    return '';
                }
                const langName = lngs[0].toLowerCase();
                return `${cdnUrl}project/${ langName }.json`;
            },
            parse: function (data: string) {
                return JSON.parse(data);
            },
            queryStringParams: { v: '2.0' }
        },
        debug: false,
        interpolation: {
            escapeValue: false
        },
    });
export default i18n;
